<script>
    import { t, locale, locales } from "../../../scripts/i18n";
</script>

<div class="panel-block-wrap mx-auto">
    <div class="panel-header">
        <slot name="icon">
            <img src="/static/media/bx_bx-target-lock.b1504136.svg" alt="/" class="scan-block_top-img mr-5px">
        </slot>
        <div class="title-wrap">
            <slot name="title">
                <span>Loading...</span>
            </slot>
        </div>
        <slot name="back-btn">
            <a href="/demo">
                <img src="/static/media/back.9eb4f248.svg" width="30" alt="/">
            </a>
        </slot>
    </div>
    <div class="panel-content">
        <slot name="content"></slot>
    </div>

</div>

<div class="back-to-dashboard text-center">
    <a class="" href="/demo">
        <img src="/static/media/home.92ef2d1d.svg" class="icon">
        {$t('Return to dashboard')}
    </a>
</div>

<style>


    .panel-content {
        padding: 20px 15px 0;
    }
    .panel-header {
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        display: flex;
        padding: 13px 20px;
        border-bottom: 1px solid;
    }
    .panel-header .title-wrap {
        flex-grow: 1;

        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 20px;
        line-height: 23px;
        text-align: left;
        display: inline-block;
        vertical-align: top;
    }
    .panel-block-wrap {
        margin-top: 50px;
        max-width: 1100px;
        width: 100%;
        min-height: 630px;
        background: #fff;
        border: 0.5px solid #8a8585;
        box-sizing: border-box;
        box-shadow: 0 4px 10px rgba(0,0,0,.25);
        border-radius: 21px;
        padding-bottom: 45px;
        margin-bottom: 30px;
    }

    .back-to-dashboard {
        padding-bottom: 20px;
        display: inline-block;
        font-family: Roboto;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        width: 100%;
    }

    @media (max-device-width: 480px) {
        .panel-header {
            flex-wrap: nowrap;
        }
    }
</style>